import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateBlogTemplateCategories } from '../Admin/Template/useAdminBlogTemplateCategories';
import { invalidateAllHwcIndustryCategoryTemplates } from '../Admin/Template/useHwcIndustryCategoryTemplates';
import { invalidateEmailAllCategoryTemplates } from '../EmailCampaign/useEmailAllCategoryTemplates';
import { invalidateAllTemplateCategorySocialQueries } from './useTemplateCategorySocialQuery';

interface IParams {
	template: Api.ITemplate;
	forUserId?: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useTemplateCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ITemplate, variables: IParams) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ template, forUserId, impersonationContext }: IParams) =>
			userSession.webServiceHelper.callAsync<Api.ITemplate>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `template`,
					queryParams: {
						forUserId,
					},
					impersonationContext,
				}),
				`POST`,
				template
			),
		onError,
		onSuccess: (data, variables) => {
			invalidateAllHwcIndustryCategoryTemplates();
			invalidateBlogTemplateCategories();
			invalidateAllTemplateCategorySocialQueries();
			invalidateEmailAllCategoryTemplates();

			// Call the original onSuccess callback if provided
			onSuccess?.(data, variables);
		},
	});
}
